import 'picturefill';
import $ from './boot/_jquery';
import '@fancyapps/fancybox';
import './thirdparty/superfish';
import './thirdparty/hoverIntent';
import './thirdparty/jquery.cycle2';
import './thirdparty/NocaptchaField';
import StickyController from './classes/StickyController';

$(function () {
	"use strict";

	var $nav = $('nav');
	$('a.nav-toggle').on('click', function (event) {
		if ($nav.is(':visible')) {
			$nav.slideUp();
		} else {
			$nav.slideDown();
		}

		event.preventDefault();
	});

	$nav.find('ul').superfish();

	var $cycle = $('.cycle');
	if ($cycle.length) {
		$cycle.height($cycle.height());
		$cycle.cycle();
		$cycle.parent().addClass('cycle-init');

		setTimeout(function () {
			$cycle.height('auto');
		}, 100);
	}

	var $map = $('#map');
	if ($map.length) {
		var height = $map.width() / 2.4;

		if (height > 360) {
			height = 360;
		} else if (height < 200) {
			height = 200;
		}
		$map.height(height);

		var latLng = new google.maps.LatLng(gMap.lat, gMap.lon),
			map = new google.maps.Map(document.getElementById("map"), {
				center: latLng,
				zoom: 15,
				scrollwheel: false,
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				styles: [{
					"featureType": "poi.business",
					"stylers": [
						{"visibility": "off"}
					]
				}]
			}),
			marker = new google.maps.Marker({
				position: latLng,
				map: map,
				title: 'Stratstan'
			});

		$(window).on('resize', function () {
			var height = $map.width() / 2.4;

			if (height > 360) {
				height = 360;
			} else if (height < 200) {
				height = 200;
			}
			$map.height(height);
			google.maps.event.trigger(map, 'resize');
			map.setCenter(latLng);
		});
	}

	$(function () {
		var $wrappers = $('.js-sticky');
		$wrappers.each(function () {
			new StickyController($(this));
		});
	});

	$popup = $('#popup-form');
	$popup.find('.g-recaptcha').attr('data-callback', 'handlePopupFormSubmission');
});

let $popup;
window['handlePopupFormSubmission'] = function () {
	const $form = $popup.find('form');
	const url = $form.attr('action');
	const data = $form.serialize();
	$.fancybox.getInstance().showLoading();

	$.ajax({
		type: 'POST',
		url,
		data,
		success: (data) => {
			$.fancybox.getInstance().hideLoading();

			if (data === 'complete') {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'FormSubmitted',
					'FormTitle': 'Popup Form'
				});
				$popup.find('.popup-form__content').hide();
				$popup.find('.popup-form__confirmation').show();
				return;
			}

			$form.replaceWith(data);
			$popup.find('.g-recaptcha').attr('data-callback', 'handlePopupFormSubmission');
		}
	});
};

$(() => {
	const $form = $('.js-resources-filter');
	const submitForm = () => {
		// Legacy browser :( just use old fashioned form submission
		if (!window.history || !window.history.pushState) {
			$form.submit();
			return;
		}

		const url = $form.attr('action') + '?' + $form.serialize();
		history.pushState({}, '', url);

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				$('.js-resources-list').replaceWith(data.results);
			}
		});
	}

	$form.find('select').on('change', submitForm);
})
